import useFormDataGetPageDataByRequest from '../../../@hooks/useFormDataGetPageDataByRequest'
import service from '../../../@services'
import {inventoryTypeEnum} from "../config";
export default function useGetProductTransfersList(activeKey) {
  console.log('activeKey='+activeKey);
  const _getListApi = activeKey === 'in'? service.inventory.allocationInList: service.inventory.allocationOutList
  const { pageData, getList, loading } = useFormDataGetPageDataByRequest(_getListApi)
  return {
    pageData,
    getList,
    loading
  }
}
